import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { push } from "redux-first-history";
import { leaveQueue, hideRoulette } from "../../redux/actions/queues";
import Roulette from "../roulette/Roulette";

import frame0 from "../../assets/images/loading-0.webp";
import frame1 from "../../assets/images/loading-1.webp";
import frame2 from "../../assets/images/loading-2.webp";
import frame3 from "../../assets/images/loading-3.webp";
import frame4 from "../../assets/images/loading-4.webp";
import frame5 from "../../assets/images/loading-5.webp";

import "./Loading.scss";

const frames = [frame0, frame1, frame2, frame3, frame4, frame5];
// Zig-zag: enche 0→5 e esvazia 5→0
const SEQUENCE = [0, 1, 2, 3, 4, 5, 4, 3, 2, 1];
const STEP_MS = 220;

function Loading() {
  const loadingStatus = useSelector((state) => state.communication.loadingStatus);
  const searching = useSelector((state) => state.queues.searching);
  const roulette = useSelector((state) => state.roulette);
  const dispatch = useDispatch();

  const visible = loadingStatus > 0 || searching;
  const [idx, setIdx] = useState(0);

  // Pre-carrega os 6 frames no boot para o primeiro "Procurando partida"
  // nao esperar o download dos PNGs (evita delay no mobile)
  useEffect(() => {
    frames.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  useEffect(() => {
    if (!visible) {
      setIdx(0);
      return;
    }
    const interval = setInterval(() => {
      setIdx((prev) => (prev + 1) % SEQUENCE.length);
    }, STEP_MS);
    return () => clearInterval(interval);
  }, [visible]);

  // Spin-go: renderiza a roleta quando ativa (prioridade sobre o loading padrão)
  if (roulette && roulette.visible) {
    return (
      <Roulette
        spins={roulette.spins}
        prize={roulette.prize}
        bet={roulette.bet}
        onComplete={() => {
          dispatch(hideRoulette());
          dispatch(push("/game"));
        }}
      />
    );
  }

  if (!visible) return null;

  const frameIdx = SEQUENCE[idx];
  const currentFrame = frames[frameIdx];
  // Rotação acompanha a sequência: cresce enchendo (0->300°), volta esvaziando
  const rotation = frameIdx * 60;

  return (
    <div id="xp-loader">
      <div className="xp-loader__card">
        <div className="xp-loader__header">
          <h2 className="xp-loader__title">Procurando partida...</h2>
          <button
            type="button"
            className="xp-loader__close"
            onClick={() => dispatch(leaveQueue())}
            aria-label="Fechar"
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        <p className="xp-loader__sub">Vamos começar em no máximo 30 segundos</p>

        <div className="xp-loader__revolver">
          <div
            className="xp-loader__spinner"
            style={{
              transform: `rotate(${rotation}deg)`,
              transition: `transform ${STEP_MS}ms linear`,
            }}
          >
            <img
              className="xp-loader__frame"
              src={currentFrame}
              alt=""
              draggable={false}
            />
          </div>
        </div>

        <button
          type="button"
          onClick={() => dispatch(leaveQueue())}
          className="xp-loader__cancel"
        >
          Cancelar
        </button>
        <div className="xp-loader__home-indicator" aria-hidden="true">
          <span className="xp-loader__home-pill" />
        </div>
      </div>
    </div>
  );
}

export default Loading;
